

class Config
{
        static url = "https://www.magicznewrota.pl"; 

}  

export default Config;